import React, { useEffect, useState } from 'react';
import {FormattedHTMLMessage, FormattedMessage } from 'react-intl'

import {
  img_discover_splash,
  sprite_flower_blue,
  sprite_long_arrow,
} from '../../assets/imgs';

const Discover = (props) => {

  // Traits reveal animation
  useEffect(() => {
    const traits = Array.from(document.querySelectorAll(".discover .trait"));
    const traitsRevealDelay = 100;

    const traitObserverConfig = {
      root: null,
      rootMargin: "0px",
      threshold: 0.4,
    };

    function getYPos(elem) {
      const rect = elem.getBoundingClientRect();
      const scrollTop = window.scrollY;
      return rect.top + scrollTop;
    }


    const traitObserverCallback = (entries, observer) => {
      entries.forEach((entry) => {
        const trait = entry.target;
        const traitContents = Array.from(trait.children);

        if (entry.isIntersecting) {
          setTimeout(() => {
            trait.classList.remove("hidden");
            traitContents.forEach((content) => {
              content.classList.remove("hidden");
            });
            observer.unobserve(trait);
          }, traitsRevealDelay);
        }
      });
    };

    const traitObserver = new IntersectionObserver(
      traitObserverCallback,
      traitObserverConfig
    );

    traits.forEach((trait) => {
      const traitContents = Array.from(trait.children);
      traitContents.forEach((content, i) => {
        content.classList.add("hidden");
        content.style.transition = `opacity ease-in-out 300ms ${i * traitsRevealDelay}ms`;
      });

      const scrollHandler = () => {
        const scrollTop = window.scrollY;
        const scrollBottom = scrollTop + window.innerHeight;
        const traitTop = getYPos(trait);

        if (traitTop < scrollBottom) {
          setTimeout(() => {
            trait.classList.remove("hidden");
            traitContents.forEach((content) => {
              content.classList.remove("hidden");
            });
          }, traitsRevealDelay);
        } else {
          traitObserver.observe(trait);
        }
      };

      scrollHandler();
      window.addEventListener('scroll', scrollHandler);

      return () => {
        window.removeEventListener('scroll', scrollHandler);
      };
    });

    return () => {
      traits.forEach((trait) => {
        traitObserver.unobserve(trait);
      });
    };
  }, []);

  // Background flowers rotation
  const [lastScrollY, setLastScrollY] = useState(window.scrollY);
  const [ticking, setTicking] = useState(false);
  const flowers = Array.from(document.querySelectorAll(".splash .flower"));
  const flowerStartAngle = 33;

  const rotateFlower = (flower, i) => {
    const rotationSpeed = 0.075;
    const angle = lastScrollY * rotationSpeed;

    if (i % 2 === 0) {
      flower.style.transform = `rotate(${flowerStartAngle + angle * 0.75}deg)`;
    } else {
      flower.style.transform = `rotate(${flowerStartAngle - angle}deg)`;
    }
  };

  const rotateFlowersOnScroll = () => {
    flowers.forEach((flower, i) => {
      rotateFlower(flower, i);
    });

    setTicking(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      setLastScrollY(window.scrollY);

      if (!ticking) {
        window.requestAnimationFrame(rotateFlowersOnScroll);
        setTicking(true);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [ticking]);

  return (
    <section className="discover">
      <div className="discover-wrapper">
        <div className="splash">
          <h4><FormattedMessage id="discover.page_title" defaultMessage="Discover Define®" /></h4>
          <img
            className="model"
            src={img_discover_splash}
            alt="Model wearing Acuvue Define® product"
          />
          <img src={sprite_flower_blue} className="flower left" />
          <img src={sprite_flower_blue} className="flower right" />
          <img src={sprite_long_arrow} className="long-arrow" />
        </div>
        <ul className="traits">
          <li className="trait hidden">
            {/* <FormattedMessage id="discover.trait_01.title" defaultMessage="<em>Beauty Wrapped In Comfort™ </em>technology" tagName='h4'/> */}
            <h4>
              {/* <em> <FormattedMessage id="discover.trait_01.title_part01" defaultMessage="Beauty Wrapped In Comfort™" /> </em> */}
              {/* <FormattedMessage id="discover.trait_01.title_part02" defaultMessage="technology" /> */}
              {/* 獨特 BWIC™ 透氧隔色科技 */}
              <FormattedMessage id="discover.trait_01.title" defaultMessage="<em>Beauty Wrapped In Comfort™ </em>technology" values={{ em: msg =>  <em> {msg} </em> }} />
            </h4>
            <p>
              <FormattedHTMLMessage
                id="discover.trait_01.body"
                defaultMessage="Pigments are safely embedded within the lens material, so that they don’t come in contact with your eyes."
              />
            </p>
          </li>
          <li className="trait hidden">
            {/* <FormattedMessage id="discover.trait_02.title" defaultMessage="<em>All-day UV protection </em>and&nbsp;confidence" tagName='h4'/> */}
            <h4>
              <FormattedHTMLMessage id="discover.trait_02.title" defaultMessage="<em>All-day UV protection </em>and confidence" />
            </h4>
            <p>
              <FormattedHTMLMessage
                id="discover.trait_02.body"
                defaultMessage="Stay safe from harmful UV radiation with one of the highest UV protection levels available in a daily disposable contact lens."
              />
            </p>
          </li>

          <li className="trait hidden">
            <h4>
              <FormattedMessage id="discover.trait_03.title" defaultMessage="<em>Layered</em> print process" values={{ em: msg =>  <em> {msg} </em> }} />
            </h4>
            <p>
              <FormattedMessage
                id="discover.trait_03.body"
                defaultMessage="A harmonious blend of three translucent, hand-drawn layers crafted to highlight, accentuate and naturally blend into the iris."
              />
            </p>
          </li>

          <li className="trait hidden">

            <h4>
              <FormattedMessage id="discover.trait_04.title" defaultMessage="Crafted for <em>all-day comfort</em>" values={{ em: msg =>  <em> {msg} </em> }} />
            </h4>

            <h6>
              <FormattedMessage id="discover.trait_04.item_01.title" defaultMessage="Edge design"  />
            </h6>
            <p>
              <FormattedMessage id="discover.trait_04.item_01.body" defaultMessage="Thin on-eye edge profile designed to curb lid irritation when blinking."  />
            </p>

            <h6>
              <FormattedMessage id="discover.trait_04.item_02.title" defaultMessage="Wettability**"  />
            </h6>
            <p>
              <FormattedMessage id="discover.trait_04.item_02.body" defaultMessage="Technology that is designed to support the tear film to help minimise dryness."  />
            </p>

            <h6>
              <FormattedMessage id="discover.trait_04.item_03.title" defaultMessage="Modulus"  />
            </h6>
            <p>
              <FormattedMessage id="discover.trait_04.item_03.body" defaultMessage="A lower modulus wraps the eye with less lid and cornea mechanical resistance for increased comfort." />
            </p>
          </li>
        </ul>
      </div>
    </section>
  );
};

export default Discover;
